// extracted by mini-css-extract-plugin
module.exports = {"Root":"Navbar_Root__3_exF","Logo":"Navbar_Logo__1e2yM","Icons":"Navbar_Icons__2WZCu","AppIdentity":"Navbar_AppIdentity__3reX2"};